import React from "react";
import { Phone, MapPin, Mail } from "lucide-react";
import { CONTACT, NAV_LINKS, POPULAR_PICKUPS, LOGO } from "../mock";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const Footer = () => {
  return (
    <footer className="bg-stone-900 text-stone-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={LOGO}
                alt="Mallikarjuna Tours & Travels"
                className="h-16 w-auto object-contain bg-white rounded-xl p-1.5"
              />
            </div>
            <p className="text-sm text-stone-400 leading-relaxed">
              Your trusted partner for Hyderabad to Srisailam pilgrimage cab tours
              for over a decade.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-display text-white text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <button
                    onClick={() => scrollTo(l.to)}
                    className="text-sm text-stone-400 hover:text-amber-400 transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Popular pickups */}
          <div>
            <h4 className="font-display text-white text-lg mb-4">
              Popular Pickups
            </h4>
            <div className="flex flex-wrap gap-2">
              {POPULAR_PICKUPS.map((p) => (
                <span
                  key={p}
                  className="text-xs px-3 py-1 rounded-full bg-stone-800 text-stone-400"
                >
                  {p}
                </span>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-white text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 text-amber-500 mt-0.5" />
                <div>
                  <a href={`tel:+91${CONTACT.primary}`} className="hover:text-amber-400">
                    {CONTACT.primary}
                  </a>
                  <br />
                  <a href={`tel:+91${CONTACT.secondary}`} className="hover:text-amber-400">
                    {CONTACT.secondary}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-amber-500 mt-0.5" />
                <span>{CONTACT.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 text-amber-500 mt-0.5" />
                <span>{CONTACT.email}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-stone-500">
          <p>
            © {new Date().getFullYear()} Mallikarjuna Tours &amp; Travels. All
            rights reserved.
          </p>
          <p>Hyderabad • Srisailam • Telangana</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
